// assets/types.js

/**
 * @typedef {'keep'|'regenerate'|'improve'} RegenerateActionType
 */

/**
 * @typedef {Object} RegenerateAction
 * @property {string} questionId
 * @property {string} [question]
 * @property {RegenerateActionType} action
 */

/**
 * @typedef {Object} QuizRegeneratePayload
 * @property {string} taskId
 * @property {number} no_of_questions
 * @property {number} difficulty_level
 * @property {string} subject
 * @property {RegenerateAction[]} actions
 */

/**
 * Action constants (UX-safe + autocomplete)
 * @readonly
 */
const ACTION = /** @type {const} */ ({
  KEEP: 'keep',
  REGENERATE: 'regenerate',
  IMPROVE: 'improve',
});